export const SUCCESS = 200;

// CLIENT SIDE ERRORS
export const BAD_REQUEST_400 = 400;
export const FORBIDDEN_403 = 403;
export const NOT_FOUND_404 = 404;

// SERVER SIDE ERRORS
export const INTERNAL_SERVER_ERROR_500 = 500;
export const SERVICE_UNAVAILABLE_503 = 503;
export const GATEWAY_TIMEOUT_504 = 504;

export const badRequestResponse = () => {
  return new Response("Bad Request", { status: BAD_REQUEST_400 });
};

export const forbiddenResponse = () => {
  return new Response("Access Denied", { status: FORBIDDEN_403 });
};
export const notFoundResponse = () => {
  return new Response("Not Found", { status: NOT_FOUND_404 });
};

export const internalServerErrorResponse = () => {
  return new Response("Internal Server Error", {
    status: INTERNAL_SERVER_ERROR_500,
  });
};
export const serviceUnavailableResponse = (detail = "Service Unavailable") => {
  // statusText is set because ErrorPage renders it as the heading for statuses
  // that have no dedicated error component.
  return new Response(detail, {
    status: SERVICE_UNAVAILABLE_503,
    statusText: "Service Unavailable",
  });
};
export const gatewayTimeoutResponse = () => {
  return new Response("Gateway Timeout", { status: GATEWAY_TIMEOUT_504 });
};

export const successResponse = () => {
  return new Response("OK", { status: SUCCESS });
};

export const HREF_BEFORE_GET_SESSION = "hrefBeforeGetSession";
